(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalFirmDeleteController',AppraisalFirmDeleteController);

    AppraisalFirmDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppraisalFirm'];

    function AppraisalFirmDeleteController($uibModalInstance, entity, AppraisalFirm) {
        var vm = this;

        vm.appraisalFirm = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppraisalFirm.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
